import React from "react";
import { CreditCard } from "react-feather";
import { CardsEnum } from "../../../shared/constants/CardsEnum";
import { Alia, Amex, Carnet, Dinners, Discover, JCB, Mastercard, Visa, } from "../../../assets/logos";
export var BrandIcon = function (props) {
    var cardBrands = function (image) {
        var cardImage = React.createElement(React.Fragment, null);
        if (image === null || image === void 0 ? void 0 : image.includes("https")) {
            cardImage = (React.createElement("svg", { style: { width: "37px", height: "25px" } },
                React.createElement("image", { style: { width: "37px", height: "25px" }, xlinkHref: image })));
        }
        else {
            cardImage = cardBrandStatic(image);
        }
        return cardImage;
    };
    return cardBrands(props.image);
};
var cardBrandStatic = function (image) {
    var cardImage = React.createElement(React.Fragment, null);
    switch (image) {
        case CardsEnum.visa:
            cardImage = React.createElement(Visa, null);
            break;
        case CardsEnum.mastercard:
            cardImage = React.createElement(Mastercard, null);
            break;
        case CardsEnum.amex:
        case CardsEnum.american_express:
            cardImage = React.createElement(Amex, null);
            break;
        case CardsEnum.diners:
            cardImage = React.createElement(Dinners, null);
            break;
        case CardsEnum.discover:
            cardImage = React.createElement(Discover, null);
            break;
        case CardsEnum.alia:
            cardImage = React.createElement(Alia, null);
            break;
        case CardsEnum.carnet:
            cardImage = React.createElement(Carnet, null);
            break;
        case CardsEnum.jcb:
            cardImage = React.createElement(JCB, null);
            break;
        default:
            cardImage = React.createElement(CreditCard, { color: "#6D7781", size: 22 });
            break;
    }
    return cardImage;
};
export default BrandIcon;
